module.exports = __webpack_public_path__ + "img/Security2_CN@3x.c3bd1581.png";